import script from "./TableAddSearchRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TableAddSearchRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__